import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-295cb23f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "badge badge-lg badge-light-primary" }
const _hoisted_2 = { class: "d-flex align-items-center flex-wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "svg-icon svg-icon-2 svg-icon-primary mx-2"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-chevron-right" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("a", {
            href: "javascript:void(0)",
            onClick: ($event: any) => (_ctx.selectCrumb(item))
          }, _toDisplayString(item.text), 9, _hoisted_3),
          (!item.current)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}